import React from 'react';
import {IHeaderRelatedSite} from "../../../../services/configurations/config-data-sections/header.configuration";
import {observer} from "mobx-react";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {RelatedSiteLink, RelatedSiteLinkBox} from "./boxes/related-site-link.box";
import {Link} from "../../../raw-components/link/link";

interface RelatedSiteComponentProps {
    config: IHeaderRelatedSite;
}
export const RelatedSiteComponent: React.FC<RelatedSiteComponentProps> = observer((props) => {
   const services = useServices();
    const url = services.linksNavigation.getLinkUrl(props.config.linkId)
    return (
        <RelatedSiteLinkBox key={props.config.linkId}>
            <Link href={url}
                  box={RelatedSiteLink}
                  onClick={async () => {
                      await services.linksNavigation.navigateLink({
                          linkId: props.config.linkId
                      });
                  }}>
                {props.config.text}
            </Link>
        </RelatedSiteLinkBox>
    );
});